import { privateApi, publicApi } from "./axios";

export const linkWithOffice = async (idToken: string, accessToken: string) => {
    try {
        const response = await publicApi.post("api/users/link/office", { idToken, accessToken });
        return response;
    } catch (error) {
        throw error;
    }
}

export const checkAuth = async () => {
    try {
        const response = await privateApi.get("api/users/checkauth");
        return response.data;
    } catch (error) {
        throw error;
    }
}

export const getWhoami = async () => {
    try {
        const response = await privateApi.get("api/users/whoami");
        return response.data;
    } catch (error) {
        throw error;
    }
}

export const getUsers = async (active?: boolean | null) => {
        try {
            const response = await privateApi.get(`api/users?active=${active}`);
            return response;
    } catch (error) {
        throw error;
    }
}

export const getUser = async (idUser: number) => {
    try {
        const response = await privateApi.get(`api/users/${idUser}`);
        return response;
    } catch (error) {
        throw error;
    }
}

export const createUser = async (data: any) => {
    try {
        const response = await privateApi.post("api/users", data);
        return response;
    } catch (error) {
        throw error;
    }
}

export const updateUser = async (idUser: number, data: any) => {
    try {
        const response = await privateApi.patch(`api/users/${idUser}`, data);
        return response;
    } catch (error) {
        throw error;
    }
}

export const getTimesForUser = async (idUser: number, date: string) => {
    try {
        const response = await privateApi.get(`api/users/${idUser}/times?startDate=${date}`);
        return response;
    } catch (error) {
        throw error;
    }
}

export const postTime = async (idUser: number, data: any) => {
    try {
        const response = await privateApi.post(`api/users/${idUser}/time`, data);
        return response;
    } catch (error) {
        throw error;
    }
}

export const deleteUser = async (idUser: number) => {
    try {
        const response = await privateApi.delete(`api/users/${idUser}`);
        return response;
    } catch (error) {
        throw error;
    }
}

export const getInformationUser = async () => {
    try {
        const response = await privateApi.get(`api/whoami`);
        return response;
    } catch (error) {
        throw error;
    }
}

export const getManagers = async () => {
    try {
        const response = await privateApi.get(`api/users/managers`);
        return response;
    } catch (error) {
        throw error;
    }
}
// Productions
export const getUsersProductions = async (startDate: string, endDate: string) => {
    try {
        const response = await privateApi.get(`api/users/report/times?startDate=${startDate}&endDate=${endDate}`);
        return response;
    } catch (error) {
        throw error;
    }
}

export const sendAccess = async (idUser: number) => {
    try {
        const response = await privateApi.post(`api/users/${idUser}/sendcreationemail`);
        return response;
    } catch (error) {
        throw error;
    }
}

export const getTimeByCollab = async (idUser: number, date: string) => {
    try {
        const response = await privateApi.get(`api/users/report/${idUser}/times/yearly?year=${date}`);
        return response;
    } catch (error) {
        throw error;
    }
}

export const getTimeSheet1 = async (idUser: number, date: string) => {
    try {
        const response = await privateApi.get(`api/users/report/${idUser}/times/daily?year=${date.split("-")[0]}&month=${date.split("-")[1]}`);
        return response;
    } catch (error) {
        throw error;
    }
}

export const getTimeSheet2 = async (idUser: number, date: string) => {
    try {
        const response = await privateApi.get(`api/users/report/${idUser}/times/daily?year=${date.split("-")[0]}&month=${date.split("-")[1]}&chargeable=true`);
        return response;
    } catch (error) {
        throw error;
    }
}

export const getTimeSheet3 = async (idUser: number, date: string) => {
    try {
        const response = await privateApi.get(`api/users/report/${idUser}/times/daily?year=${date.split("-")[0]}&month=${date.split("-")[1]}&chargeable=false`);
        return response;
    } catch (error) {
        throw error;
    }
}

export const getHolidays = async (date: string) => {
    try {
        const response = await privateApi.get(`api/users/report/holidays?year=${date.split("-")[0]}&month=${date.split("-")[1]}&type=congé`);
        return response;
    } catch (error) {
        throw error;
    }
}

export const getAbsences = async (date: string) => {
    try {
        const response = await privateApi.get(`api/users/report/holidays?year=${date.split("-")[0]}&month=${date.split("-")[1]}&type=absence`);
        return response;
    } catch (error) {
        throw error;
    }
}
